import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

const Item1: React.FC<EmptyProps> = () => {
	return (
		<li className="flex items-start gap-2">
			<span className="mt-0.5 shrink-0">•</span>
			<Text variant="body" className="text-typography-strong">
				<span className="font-bold">
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_1_bold" />
				</span>
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_1" />
			</Text>
		</li>
	);
};

const Item2: React.FC<EmptyProps> = () => {
	return (
		<li className="flex items-start gap-2">
			<span className="mt-0.5 shrink-0">•</span>
			<Text variant="body" className="text-typography-strong">
				<span className="font-bold">
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_2_bold" />
				</span>
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_2" />
			</Text>
		</li>
	);
};

const Item3: React.FC<EmptyProps> = () => {
	return (
		<li className="flex items-start gap-2">
			<span className="mt-0.5 shrink-0">•</span>
			<Text variant="body" className="text-typography-strong">
				<span className="font-bold">
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_3_bold" />
				</span>
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_3" />
			</Text>
		</li>
	);
};

const Item4: React.FC<EmptyProps> = () => {
	return (
		<li className="flex items-start gap-2">
			<span className="mt-0.5 shrink-0">•</span>
			<Text variant="body" className="text-typography-strong">
				<span className="font-bold">
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_4_bold" />
				</span>
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_4" />
			</Text>
		</li>
	);
};

const Item5: React.FC<EmptyProps> = () => {
	return (
		<li className="flex items-start gap-2">
			<span className="mt-0.5 shrink-0">•</span>
			<Text variant="body" className="text-typography-strong">
				<span className="font-bold">
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_5_bold" />
				</span>
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.help_modal.list_item_5" />
			</Text>
		</li>
	);
};

export const HelpModalList: React.FC<EmptyProps> = () => {
	return (
		<ul className="flex list-none flex-col gap-3 pl-0">
			<Item1 />
			<Item2 />
			<Item3 />
			<Item4 />
			<Item5 />
		</ul>
	);
};
